const CORE_BRANCH_STORAGE_KEY = "selectedCoreBranch";
const CHANNEL_BRANCH_STORAGE_KEY = "selectedChannelBranch";
export const BRANCH_SELECTION_CHANGED_EVENT = "branch-selection:changed";

export const CHANNEL_ROUTE_PREFIXES = [
  "/mandate-batches-reports",
  "/mandate-reports",
  "/create-mandate",
  "/mandate/upload-mandate",
  "/mandate-batches-reports-nibss",
  "/new-mandate-batch-nibss",
  "/new-mandate-nibss",
  "/mandate-reports-nibss",
  "/collection/reports",
  "/mandate/collection-report",
  "/collection/initiate-batch-form",
  "/collection/initiate-single-form",
  "/collection-batches-nibss",
  "/new-collection-batch-nibss",
  "/collections-nibss",
  "/remita-loan-requests",
  "/remita-collection-batches",
  "/remita-new-batch",
  "/remita-prequalification",
  "/remita-collections",
  "/general-search",
  "/customers-report",
  "/liveness-check",
  "/loan-requests-report",
  "/transactions-report",
  "/transfers-report",
  "/general-requests-selector",
  "/mandate/view-collection",
  "/ptsp-transactions-report",
];

export const normalizeRoutePath = (path) => {
  if (!path) return "";
  const normalized = path.split("?")[0].replace(/\/+$/, "");
  return normalized || "/";
};

export const pathMatchesPrefix = (path, prefix) => {
  const normalizedPath = normalizeRoutePath(path);
  const normalizedPrefix = normalizeRoutePath(prefix);

  return (
    normalizedPrefix &&
    (normalizedPath === normalizedPrefix ||
      normalizedPath.startsWith(`${normalizedPrefix}/`))
  );
};

export const isChannelRoutePath = (path, menuList) => {
  const matchesMenuRoute = (menuList?.menus ?? []).some((menu) => {
    const routeMatches =
      pathMatchesPrefix(path, menu?.path) ||
      (menu?.submenus ?? []).some((submenu) =>
        pathMatchesPrefix(path, submenu?.path)
      );

    return (
      routeMatches &&
      (menu?.menu_groups ?? []).includes("AdminManageChannels")
    );
  });

  return (
    matchesMenuRoute ||
    CHANNEL_ROUTE_PREFIXES.some((prefix) => pathMatchesPrefix(path, prefix))
  );
};

const readStorageValue = (key) => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(key);
};

const writeStorageValue = (key, value) => {
  if (typeof window === "undefined" || value == null || value === "") return;
  window.localStorage.setItem(key, String(value));
};

const notifyBranchSelectionChanged = (type, branch) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(BRANCH_SELECTION_CHANGED_EVENT, {
      detail: {
        type,
        branch: branch == null ? null : String(branch),
      },
    })
  );
};

export const getStoredCoreBranch = () =>
  readStorageValue(CORE_BRANCH_STORAGE_KEY);

export const setStoredCoreBranch = (branch) => {
  writeStorageValue(CORE_BRANCH_STORAGE_KEY, branch);
  notifyBranchSelectionChanged("core", branch);
};

export const setStoredCoreBranchSilently = (branch) =>
  writeStorageValue(CORE_BRANCH_STORAGE_KEY, branch);

export const getStoredChannelBranch = () =>
  readStorageValue(CHANNEL_BRANCH_STORAGE_KEY);

export const setStoredChannelBranch = (branch) => {
  writeStorageValue(CHANNEL_BRANCH_STORAGE_KEY, branch);
  notifyBranchSelectionChanged("channel", branch);
};

export const setStoredChannelBranchSilently = (branch) =>
  writeStorageValue(CHANNEL_BRANCH_STORAGE_KEY, branch);

export const getSelectedBranchHeaders = () => {
  const currentPath =
    typeof window === "undefined" ? "" : window.location.pathname;
  const isChannelRoute = isChannelRoutePath(currentPath);
  const branchKey = isChannelRoute
    ? getStoredChannelBranch()
    : getStoredCoreBranch();

  if (!branchKey) {
    return {};
  }

  return isChannelRoute ? { cbid: branchKey } : { bid: branchKey };
};
